var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgPetPriority(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.174h44v28.154a4.715 4.715 0 01-4.717 4.663H6.717A4.717 4.717 0 012 41.284V13.13v.044z",
    fill: "#6CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.553 2h32.894A5.553 5.553 0 0146 7.552v2.64H2v-2.64A5.551 5.551 0 017.553 2z",
    fill: "#FFA64D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.574 18.937v17.27a2.64 2.64 0 01-2.64 2.64H7.861a2.64 2.64 0 01-2.64-2.64v-17.27a2.683 2.683 0 012.64-2.64h12.038a2.684 2.684 0 012.64 2.64h.035zM41.371 41.081H6.18a.994.994 0 100 1.989h35.191a.994.994 0 100-1.989zM42.374 18.857v5.138a2.64 2.64 0 01-2.64 2.596H27.582a2.57 2.57 0 01-1.919-.88 2.639 2.639 0 01-.669-1.76v-5.094a2.639 2.639 0 012.588-2.595h12.196a2.64 2.64 0 012.596 2.595zM42.374 31.122v5.191a2.64 2.64 0 01-2.64 2.587H27.582a2.588 2.588 0 01-2.588-2.587v-5.19a2.586 2.586 0 012.588-2.587h12.196a2.64 2.64 0 012.596 2.586z",
    fill: "#E6F9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.042 7.957a1.857 1.857 0 100-3.714 1.857 1.857 0 000 3.714zM13.88 7.957a1.857 1.857 0 100-3.714 1.857 1.857 0 000 3.714zM20.718 7.957a1.857 1.857 0 100-3.714 1.857 1.857 0 000 3.714zM21.44 16.754L5.185 31.034V18.936a2.683 2.683 0 012.64-2.64h12.073a2.64 2.64 0 011.54.458zM36.47 16.262l-10.807 9.493a2.639 2.639 0 01-.669-1.76v-5.138a2.639 2.639 0 012.588-2.595h8.888zM34.63 28.536l-9.556 8.393a2.497 2.497 0 01-.08-.633v-5.174a2.586 2.586 0 012.588-2.586h7.048z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h44v44H0z"
  })))));
}
export default SvgPetPriority;